import { h } from 'vue';

const aliasMap = {
  'circle-fill': 'circle',
  trash: 'trash',
  eye: 'eye',
  'eye-fill': 'eye',
};

const BIcon = {
  name: 'BIcon',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
  setup(props, { attrs }) {
    return () => h('fa-icon', { name: aliasMap[props.icon] || props.icon, ...attrs });
  },
};

const BIconEye = {
  name: 'BIconEye',
  setup(_, { attrs }) {
    return () => h('fa-icon', { name: 'eye', ...attrs });
  },
};

const BIconEyeFill = {
  name: 'BIconEyeFill',
  setup(_, { attrs }) {
    return () => h('fa-icon', { name: 'eye', ...attrs });
  },
};

export function registerBootstrapIconShims(app) {
  app.component('BIcon', BIcon);
  app.component('BIconEye', BIconEye);
  app.component('BIconEyeFill', BIconEyeFill);
}
